import { createContext } from 'react';

// Experience config handed to <App> by the server. The client reads the same
// values from window.__EXPERIENCE_PROPS__, so this is only needed to resolve
// switches during SSR, where there is no window.
export const ExpConfigurationContext = createContext<
  Record<string, string> | undefined
>(undefined);
